import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { toast } from 'react-toastify'
import callable from '../utils/callable'
import { getManagerApprovalCodes } from '../selectors/employeeRole'

import Keypad from '../components/tabs/TabOrderDetailsKeypad'

import { setManagerId } from '../actions/attendant'

/**
 * TODO: It is unconvential to return React components in a hook.
 * This should be replace with a more convential and flexible system
 * When time permits.
 */
const useManagerApproval = () => {
  const approvalCodeToManagerMap = useSelector(getManagerApprovalCodes)
  const dispatch = useDispatch()
  const [modalElement, setModalElement] = useState(null)

  const handleOnConfirm = (pin, success, failure) => {
    if (!!approvalCodeToManagerMap[pin]) {
      dispatch(setManagerId(approvalCodeToManagerMap[pin]))
      callable(success)
      setModalElement(null)
    } else {
      callable(failure)
      toast.error('Invalid Approval Code, Please Try Again', { autoClose: 2500 })
    }
  }

  const requestApproval = (onSuccess, onFailure) => {
    setModalElement(
      <Keypad
        secret
        maxLength={5}
        decimal={false}
        key={'passcodeConfirmKeypad'}
        onClose={() => setModalElement(null)}
        onConfirm={(pin) => handleOnConfirm(pin, onSuccess, onFailure)}
        title="Approval Code Required"
        interactionType="press"
      />
    )
  }

  return [modalElement, requestApproval]
}

export default useManagerApproval
